// Get API base URL from environment variable, fallback to default
// Vite replaces import.meta.env.* at build time
const getBaseUrl = (): string => {
  return import.meta.env?.VITE_API_BASE_URL || "https://dev-api.cointervue.com";
};

// Get API version from environment variable, fallback to default
const getApiVersion = (): string => {
  return import.meta.env?.VITE_API_VERSION || "v1";
};

export const BASE_URL = getBaseUrl();
export const SERVER_VERSION = new URL(`${getApiVersion()}/`, BASE_URL);
export const HR = new URL("hr/", SERVER_VERSION.href);
export const USER_MGMT = HR;
export const JOBS = new URL("jobs/", HR.href);
export const CANDIDATE = new URL("candidate/", HR.href);
export const BANK = new URL("hr/", SERVER_VERSION.href);
export const INTERVIEW = new URL("interview/", SERVER_VERSION.href);

export const USER_ROUTES = {
  login: "/auth/login",
  logout: "/auth/logout",
  verify: "/auth",
  signup: "/auth/signup",
  otpValidate: "/auth/validate-otp",
  resendOtp: "/auth/resend-otp",
  forgotPassword: "/auth/forget-password",
  resetPassword: "/auth/reset-password",
  refreshToken: "/auth/refresh-token",
};

export const CANDIDATE_ROUTES = {
  candidateStatus: "/dashboard",
  candidatesJobStatus: "/org",
  resumeAnalyze: "resume/analyze",
  downloadCandidateResume: "resume/download/",
  DownloadFeedbackReport:"report-pdf/download/",
  interviewFeedback: "/feedback",
  candidatePolling: "ttl",
};

export const JOBS_ROUTES = {
  createJobRoleWithFile: "/jd/file",
  createJobRoleWithContent: "/jd/content",
  createJobRoleWithPrompt: "/jd/prompt",
  fieldsOfJobRole: "/fields",
  createJobRole: "/create",
  editJobRole: (jobId: string) => `/${jobId}`,
  interviewStructure: "/interview-structure",
  createJobRolePolling:"ttl",
};

export const BANK_ROUTES = {
  questionsByType: "/question/topic/",
  addQuestion: "/question",
  skill: "/skill",
};

export const INTERVIEW_ROUTES = {
  scheduleInterview: "/create",
  reScheduleInterview: "/reschedule",
  fetchInterviewDetails: "/candidate",
  cancelInterview: "/cancel",
  verifyInterviewToken: "/api/interview/validate",
  preInterviewDetails: "api/interview/pre",
  interviewFeedback: "api/interview/feedback",
  createRoom: "api/interview/create-room",
  endCall: "api/interview/end-call",
  feedbackScreen: "api/interview/feedback-screen",
  getConversation: "api/interview/conversation",
  tabChange: "api/interview/tab-change",
  panelistName: "api/interview/panelistName",
  candidateProofs: "api/interview/proofs",
  convertCode: "api/interview/convert-code",
  interviewRecording: "/interview/recording",
  editPanelist: "/panel/edit/",
};
